import { render } from "./InfoMovie.vue?vue&type=template&id=04e0bbb5&scoped=true"
import script from "./InfoMovie.vue?vue&type=script&lang=js"
export * from "./InfoMovie.vue?vue&type=script&lang=js"

import "./InfoMovie.vue?vue&type=style&index=0&id=04e0bbb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e0bbb5"]])

export default __exports__